import { DefaultTheme } from 'styled-components'
import burgerMenuBlackIcon from '~/assets/images/black-burger-menu.svg'
import closeBlackIcon from '~/assets/images/black-cross.svg'
import upsellCheckIconLightGrey from '~/assets/images/check-icon-light-grey.svg'
import upsellCheckPurpleIcon from '~/assets/images/check-icon-purple.svg'
import checkIconPurple from '~/assets/images/check-purple.svg'
import payLightIcons from '~/assets/images/pay-icons-light.png'
import bgWhiteImage from '~/assets/images/phone-white-bg.webp'
import purpleDiscountBadge from '~/assets/images/purple-discount-badge.png'
import leftBrightLeaf from '~/assets/images/sprite/left-leaf.svg'
import rightBrightLeaf from '~/assets/images/sprite/right-leaf.svg'
import { COLORS, Color } from '~/shared/constants/uiConstants'

// todo: review and changed based on progress
export const BIOLOGY_THEME: DefaultTheme = {
  mode: 'light',
  colors: {
    // new
    buttonBackground: COLORS.PURPLE_700,
    buttonColor: Color.WHITE,
    disabledButtonBackground: COLORS.GRAY_400,
    defaultTextColor: Color.BLACK,

    // old
    pageBackground: COLORS.TRANSPARENT,
    subtitleColor: COLORS.BLACK,
    // defaultTextColor: Color.BLACK,
    alternativeTextColor: Color.GRAY_900,
    strongTextColor: Color.PURPLE_700,
    disclaimerTextColor: 'rgba(0, 0, 0, 0.50)',
    upsellTextColor: Color.GRAY_900,
    securityBackground: 'rgba(177, 184, 213, 0.15)',
    burgerMenuBackground: Color.WHITE,
    burgerMenuCloseButtonBackground: Color.GRAY_300,
    technologiesBackground: 'rgba(177, 184, 213, 0.15)',
    reviewDateColor: Color.BLACK_ALPHA_50,
    swiperPaginationBackground: Color.GRAY_100,
    swiperBulletBackground: Color.GRAY_350,
    commonContainerBackground: 'rgba(177, 184, 213, 0.15)',
    howItWorksTextColor: Color.GRAY_940,
    ratingsColor: Color.BLACK_ALPHA_50,
    scanTextColor: Color.BLACK_ALPHA_50,
    scanBorderColor: Color.GRAY_400,
    popupBackground: `linear-gradient(180deg, ${Color.BROWN_200} 0%, ${Color.BROWN_100} 100%)`,
    progressBarColor: Color.PURPLE_700,
    progressBarBackground: Color.GRAY_300,
    highlightedColor: Color.RED_600,
    emailSubtitle: Color.BLACK_ALPHA_70,
    emailDisclaimerBackground: `linear-gradient(90deg, ${Color.BROWN_300} 0%, ${Color.YELLOW_100} 100%)`,
    inputBackground: Color.WHITE,
    hintColor: Color.GRAY_900,
    emailTipsColor: Color.GRAY_750,
    emailAutocompleteBackground: Color.WHITE,
    emailAutocompleteHoverColor: 'rgba(114, 77, 202, 0.20)',
    planItemBackground: Color.GRAY_200,
    selectedPlanItemBackground: `linear-gradient(90deg, ${Color.PURPLE_600} 0%, ${Color.BLUE_800} 81.76%)`,
    mostPopularBadgeColor: Color.WHITE,
    unselectedPriceColor: Color.GRAY_600,
    moneyBackBackground: 'rgba(177, 184, 213, 0.15)',
    paymentPopupBackground: Color.WHITE,
    upsellPlanItemBackground: 'rgba(177, 184, 213, 0.15)',
    upsellSelectedPlanItemBackground: Color.PURPLE_100,
  },
  //   pageBackground: Color.WHITE,
  //   subtitleColor: Color.GRAY_900,
  //   defaultTextColor: Color.BLACK,
  //   alternativeTextColor: Color.GRAY_900,
  //   strongTextColor: Color.PURPLE_700,
  //   disclaimerTextColor: 'rgba(0, 0, 0, 0.50)',
  //   upsellTextColor: Color.GRAY_900,
  //   buttonBackground: `radial-gradient(75.84% 111.61% at 50.15% 0%, ${Color.PURPLE_300} 0%, ${Color.BLUE_800} 85.51%, ${Color.BLUE_850} 100%)`,
  //   disabledButtonBackground:
  //     'radial-gradient(75.84% 111.61% at 50.15% 0%, rgba(189, 128, 255, 0.25) 0%, rgba(40, 15, 138, 0.25) 85.51%, rgba(31, 12, 107, 0.25) 100%)',
  //   buttonColor: Color.WHITE,
  //   securityBackground: 'rgba(177, 184, 213, 0.15)',
  //   burgerMenuBackground: Color.WHITE,
  //   burgerMenuCloseButtonBackground: Color.GRAY_300,
  //   technologiesBackground: 'rgba(177, 184, 213, 0.15)',
  //   reviewDateColor: Color.BLACK_ALPHA_50,
  //   swiperPaginationBackground: Color.GRAY_100,
  //   swiperBulletBackground: Color.GRAY_350,
  //   commonContainerBackground: 'rgba(177, 184, 213, 0.15)',
  //   howItWorksTextColor: Color.GRAY_940,
  //   ratingsColor: Color.BLACK_ALPHA_50,
  //   scanTextColor: Color.BLACK_ALPHA_50,
  //   scanBorderColor: Color.GRAY_400,
  //   popupBackground: `linear-gradient(180deg, ${Color.BROWN_200} 0%, ${Color.BROWN_100} 100%)`,
  //   progressBarColor: Color.PURPLE_700,
  //   progressBarBackground: Color.GRAY_300,
  //   highlightedColor: Color.RED_600,
  //   emailSubtitle: Color.BLACK_ALPHA_70,
  //   emailDisclaimerBackground: `linear-gradient(90deg, ${Color.BROWN_300} 0%, ${Color.YELLOW_100} 100%)`,
  //   inputBackground: Color.WHITE,
  //   hintColor: Color.GRAY_900,
  //   emailTipsColor: Color.GRAY_750,
  //   emailAutocompleteBackground: Color.WHITE,
  //   emailAutocompleteHoverColor: 'rgba(114, 77, 202, 0.20)',
  //   planItemBackground: Color.GRAY_200,
  //   selectedPlanItemBackground: `linear-gradient(90deg, ${Color.PURPLE_600} 0%, ${Color.BLUE_800} 81.76%)`,
  //   mostPopularBadgeColor: Color.WHITE,
  //   unselectedPriceColor: Color.GRAY_600,
  //   moneyBackBackground: 'rgba(177, 184, 213, 0.15)',
  //   paymentPopupBackground: Color.WHITE,
  //   upsellPlanItemBackground: 'rgba(177, 184, 213, 0.15)',
  //   upsellSelectedPlanItemBackground: Color.PURPLE_100,
  // },
  images: {
    backgroundWithPhone: bgWhiteImage,
    leftLeaf: leftBrightLeaf,
    rightLeaf: rightBrightLeaf,
    burgerMenu: burgerMenuBlackIcon,
    burgerMenuCloseButtonIcon: closeBlackIcon,
    checkIcon: checkIconPurple,
    payIcons: payLightIcons,
    upsellDiscountBadge: purpleDiscountBadge,
    upsellCheckIcon: upsellCheckIconLightGrey,
    upsellSelectedCheckIcon: upsellCheckPurpleIcon,
  },
  common: {
    emailInputOutline: `1px solid ${Color.GRAY_600}`,
    emailTipsBorder: `1px solid ${Color.GRAY_600}`,
    emailAutocompleteBoxShadow: 'none',
    selectedPlanItemBoxShadow: 'none',
    tryNowBtnShadow: 'none',
    paymentInputBorder: `1px solid ${Color.GRAY_750}`,
    headerBorder: 'none',
    headerBoxShadow: '0px -0.5px 0px 0px rgba(0, 0, 0, 0.25) inset',
    continueBtnBoxShadow: 'none',
    upsellPlanBorder: `1px solid ${Color.PURPLE_600}`,
    dots: `2px dotted ${Color.GRAY_600}`,
  },
}

export const COMMUNICATION_THEME: DefaultTheme = {
  ...BIOLOGY_THEME,
  colors: {
    ...BIOLOGY_THEME.colors,
    buttonBackground: '#096ef9',
    strongTextColor: '#096ef9',
  },
}
